import ForeignKey from '@/util/ForeignKey';
import TableRef from '@/util/TableRef';

export const checkForCreatedAt = (fk: ForeignKey, tables: TableRef[]) =>
  tables.find((t) => t.equals(fk.foreignColumn().tov() as any));
